import _ from 'lodash';
import TaxDeductionService from 'web-core/src/tax-deduction-service';
import AuthService from 'web-core/src/auth-service';

export const REQUEST_EXPENSE_CATEGORIES = 'REQUEST_EXPENSE_CATEGORIES';
export const RECEIVE_EXPENSE_CATEGORIES = 'RECEIVE_EXPENSE_CATEGORIES';

export const RECEIVE_PERSONALIZED_EXPENSE_CATEGORIES = 'RECEIVE_PERSONALIZED_EXPENSE_CATEGORIES';
export const RECEIVE_STATIC_CATEGORIES = 'RECEIVE_STATIC_CATEGORIES';

const nonDeductibleCategoryId = '5ZS9AHLTfGUaSAocU2sSqq';
const nonDeductibleMileageCategoryId = '32akuUpZDWEmu4Os8a6ECg';

const requestCategories = () => ({
  type: REQUEST_EXPENSE_CATEGORIES,
});

const receiveCategories = (data, professionIds) => ({
  type: RECEIVE_EXPENSE_CATEGORIES,
  data: { ...data, professionIds },
});

const receivePersonalizedCategories = data => ({
  type: RECEIVE_PERSONALIZED_EXPENSE_CATEGORIES,
  data,
});

const receiveStaticCategories = data => ({
  type: RECEIVE_STATIC_CATEGORIES,
  data,
});

export function fetchCategories(professionIds) {
  return (dispatch, getState, { apiClient }) => {
    // Edit: this request should always be made,
    // since the service determines the displayed array
    // const expenses = getState().expenses;
    // if (!force && _.get(expenses, 'categories.length')) {
    //   return Promise.resolve(expenses);
    // }

    dispatch(requestCategories());
    const svc = new TaxDeductionService({ client: apiClient });
    return svc.getExpenseCategories(professionIds).then((response) => {
      dispatch(receiveCategories(response, professionIds));
      return response;
    });
  };
}

export function fetchPersonalizedCategories() {
  return (dispatch, getState, { apiClient }) => {
    dispatch(requestCategories());
    const authService = new AuthService({ client: apiClient });

    return authService
      .getToken()
      .then((token) => {
        const taxSvc = new TaxDeductionService({ client: apiClient });
        return taxSvc.getPersonalizedExpenseCategories(token);
      })
      .then((response) => {
        dispatch(receivePersonalizedCategories(response));
        return response;
      });
  };
}

export function fetchStaticCategoriesIfNeeded(force = false) {
  return (dispatch, getState, { apiClient }) => {
    const { expenses } = getState();
    if (!force && !_.isEmpty(expenses.staticCategories)) {
      return Promise.resolve(expenses);
    }

    dispatch(requestCategories());
    const svc = new TaxDeductionService({ client: apiClient });
    return svc
      .getStaticCategories([nonDeductibleCategoryId, nonDeductibleMileageCategoryId])
      .then((response) => {
        const { categoryLists } = response;
        const categories = {
          nonDeductible: _.find(categoryLists, {
            externalId: nonDeductibleCategoryId,
          }),
          nonDeductibleMileage: _.find(categoryLists, {
            externalId: nonDeductibleMileageCategoryId,
          }),
        };
        dispatch(receiveStaticCategories(categories));
        return categories;
      });
  };
}
